// Highlight also the parent menu item when the page is categorized in a subcategory
jQuery('li.current-menu-parent').parent().parent().addClass('current-menu-parent');